
<ng-container *ngFor="let item of items">
    <div class="row">
        <div class="col-12 d-flex"
            *ngIf="item.type == 'TEXTAREA'"
            [ngClass]="item?.alignment" 
            [ngClass]="item?.flexAlignment" 
            >
            <div class="pb-code" [innerHTML]="item?.content | safeHtml">
            </div>
        </div>
    </div>
</ng-container>